module.exports = __webpack_public_path__ + "static/img/M_BAGS.0a6af6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/M_BAGS.jpg
// module id = Zzr3
// module chunks = 1